document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('[data-tree-gallery]').forEach(function(gallery){
    var main=gallery.querySelector('[data-tree-main-image]');
    gallery.querySelectorAll('[data-tree-thumb]').forEach(function(button){
      button.addEventListener('click',function(){
        if(main){main.src=button.dataset.src;main.srcset='';main.alt=button.dataset.alt||'';}
        gallery.querySelectorAll('[data-tree-thumb]').forEach(function(item){item.classList.remove('is-active');});
        button.classList.add('is-active');
      });
    });
  });
  document.querySelectorAll('[data-tree-product]').forEach(function(section){
    var idInput=section.querySelector('[data-variant-id]');
    var price=section.querySelector('[data-product-price]');
    var cards=section.querySelectorAll('[data-finish-card]');
    cards.forEach(function(card){card.addEventListener('click',function(){
      cards.forEach(function(item){item.classList.remove('is-active');});card.classList.add('is-active');
      if(idInput&&card.dataset.variantId){idInput.value=card.dataset.variantId;}
      if(price&&card.dataset.price){var comparePrice=card.dataset.comparePrice;price.innerHTML='<span>'+card.dataset.price+'</span>'+(comparePrice?' <s>'+comparePrice+'</s>':'');}
      var image=card.dataset.image;var main=section.querySelector('[data-tree-main-image]');if(image&&main){main.src=image;main.srcset='';}
    });});
    section.querySelectorAll('[data-qty-change]').forEach(function(button){button.addEventListener('click',function(){
      var input=section.querySelector('[data-quantity]');if(!input)return;var next=Math.max(1,(parseInt(input.value,10)||1)+parseInt(button.dataset.qtyChange,10));input.value=next;
    });});
  });
});
